"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
/* eslint-disable max-len */
/* eslint-disable quotes, indent */
var _default = {
  "inputForm.instruction": "Alle Felder sind Pflichtfelder, sofern sie nicht als optional gekennzeichnet sind",
  "inputField.label.firstName": "Vorname",
  "inputField.label.lastName": "Nachname",
  "inputField.label.fullName": "Name auf der Karte",
  "inputField.label.Email": "E-Mail",
  "inputField.label.phoneNumber": "Telefonnummer",
  "inputField.label.cardNumber": "Kartennummer",
  "inputField.label.cardExpiry": "Ablaufdatum (MM/YY)",
  "inputField.label.cardCVV": "CVC / CVV",
  "inputField.placeholder.firstName": "Max",
  "inputField.placeholder.lastName": "Mustermann",
  "inputField.placeholder.fullName": "Max Mustermann",
  "inputField.placeholder.email": "maxnustermann@cashstar.com",
  "inputField.placeholder.phoneNumber": "Telefonnummer eingeben",
  "inputField.placeholder.cardNumber": "1234 5678 9012 3456",
  "inputField.placeholder.cardExpiry": "MM/JJ",
  "inputField.placeholder.cardCVV": "3 Stellen",
  "inputField.errorMessage.invalidName": "Bitte geben Sie einen gültigen Namen ein",
  "inputField.errorMessage.incompleteField": "Feld nicht ausgefüllt",
  "inputField.errorMessage.exceedsMaxCharacters": "Überschreitet {max} Zeichen",
  "inputField.errorMessage.pleaseEnterAValidFirstName": "Bitte tragen Sie einen gültigen Vornamen ein",
  "inputField.errorMessage.pleaseEnterAValidLastName": "Bitte geben Sie einen gültigen Nachnamen ein",
  "inputField.errorMessage.pleaseEnterAValidFullName": "Bitte geben Sie einen gültigen vollständigen Namen ein",
  "inputField.errorMessage.invalidAddressValue": "Bitte geben Sie eine gültige Adresse ein",
  "inputField.errorMessage.invalidCityValue": "Bitte geben sie eine gültige Stadt ein",
  "inputField.errorMessage.pleaseEnterAValidEmailAddress": "Bitte geben Sie eine gültige E-Mail-Adresse ein",
  "inputField.errorMessage.pleaseEnterAValidPhoneNumber": "Bitte geben Sie eine gültige Telefonnummer ein",
  "inputField.errorMessage.invalidCardNumber": "Ungültige Kartennummer",
  "inputField.errorMessage.invalidCardExpiry": "Karte zu alt",
  "header.text.billingInfo": "Abrechnungsdaten",
  "submitButton.adyen.label": "Zahlen Sie jetzt",
  "inputField.label.saveCardLabel": "Speichern Sie für später",
  "inputField.label.makeAsDefaultLabel": "Als Standard markieren",
  "paymentMethod.paypal.login.initial": "Um den Checkout über PayPal abzuschließen, melden Sie sich bitte an und bestätigen Sie die Zahlungsdetails",
  "paymentMethod.paypal.login.success": "Validierung erfolgreich, bitte schließen Sie den Checkout ab",
  "paymentMethod.adyen.label": "Kreditkarte und E-Banking",
  "paymentMethod.adyen.single.label": "Kreditkarte",
  "paymentMethod.paypal.label": "PayPal",
  "paymentMethod.zippay.label": "Zip",
  "paymentMethod.zipPay.minCartAmount": "Der Mindestbestellwert für die Nutzung von Zip beträgt $35",
  "paymentMethod.zipPay.additionalCharges": "Für die Nutzung von Zip kann eine zusätzliche Händlergebühr von {amount} anfallen",
  "paymentMethod.creditCard.label": "Kreditkarte",
  "paymentMethod.googlePay.label": "Google Pay",
  "paymentMethod.applePay.label": "Apple Pay",
  "inputField.label.country": "Land",
  "inputField.label.zipcode": "Postleitzahl",
  "inputField.label.addressLine": "Adresszeile 1",
  "inputField.label.addressLineTwo": "Adresszeile 2 (Optional)",
  "inputField.label.city": "Stadt",
  "inputField.label.state": "Zustand",
  "inputField.placeholder.zipCode": "Postleitzahl",
  "inputField.placeholder.addressLine": "Adresszeile 1",
  "inputField.placeholder.addressLineTwo": "Adresszeile 2 (Optional)",
  "inputField.placeholder.city": "Stadt",
  "inputField.placeholder.state": "Zustand",
  "inputField.errorMessage.cardTypeNotSupported": "Kartentyp wird nicht unterstützt"
};
exports.default = _default;